import { useEffect } from 'react';

const useAppendCustomClassForContainer = (): void => {
  useEffect(() => {
    if (!document.head.querySelector('style[data-justdone-highlighter]')) {
      const style = document.createElement('style');
      style.setAttribute('data-justdone-highlighter', 'true');
      style.textContent = `
        .justdone-grammar-highlight {
          position: absolute;
          pointer-events: auto;
          border-bottom: 2px solid #f04438;
          background: transparent;
          transition: background 0.15s;
        }
        .justdone-grammar-highlight-category-typography {
          border-bottom: 2px solid #d01cd0;
        }
        .justdone-grammar-highlight-category-punctuation {
          border-bottom: 2px solid #d01cd0;
        }
        .justdone-grammar-highlight:hover {
          background: rgba(240, 68, 56, 0.1);
        }
        .justdone-grammar-highlight-category-typography:hover {
          background: rgba(208,28,208,0.1);
        }
        .justdone-grammar-highlight-category-punctuation:hover {
          background: rgba(208,28,208,0.1);
        }
      `;
      document.head.appendChild(style);
    }
  }, []);
};

export default useAppendCustomClassForContainer;
